import { Injectable } from "@angular/core";
import { Session } from "../models/session.model";
import { JSEncrypt } from "jsencrypt";
import { User } from "../models/user.model";

@Injectable()
export class SessionStorage {

  getDecryptedSessionData(): string {
    const session = new Session()
    session.token = this.getSessionID() || ''
    session.data = this.getSessionData() || ''
    session.publicKey = this.getPublicKey() || ''
    return session.sessionData()
  }

  getSessionID(): string | null {
    return localStorage.getItem("sessionID")
  }

  getSessionData(): string | null {
    return localStorage.getItem("sessionData")
  }

  getUnencryptedSessionData(): string | null {
    return localStorage.getItem("unencryptedData")
  }

  isImpersonated(): boolean {
    return localStorage.getItem("user.impersonated") === 'yes'
  }

  getPersistenceToken(): string | null {
    const unencryptedData = this.getUnencryptedSessionData()
    if (unencryptedData) {
      const data = JSON.parse(unencryptedData)
      return data['persistence_token']
    } else {
      return null
    }
  }

  getPublicKey(): string | null {
    return localStorage.getItem("publicKey")
  }

  setSession(session: Session) {
    if (typeof session.token === 'string') {
      localStorage.setItem("sessionID", session.token)
      localStorage.setItem("sessionData", session.data)
      localStorage.setItem("unencryptedData", session.unencryptedData)
      localStorage.setItem("publicKey", session.publicKey)
    }
  }

  resetSession() {
    localStorage.removeItem("sessionID")
    localStorage.removeItem("sessionData")
    localStorage.removeItem("publicKey")
    localStorage.removeItem("unencryptedData")
    localStorage.removeItem("decrypted")
  }

  getGuestType() {
    return localStorage.getItem("guest.type") || 'customer'
  }

  setGuestType(type: string) {
    localStorage.setItem("guest.type", type)
  }

  setUser(user: User) {
    localStorage.setItem("user.name", user.name || '')
    localStorage.setItem("user.email", user.email || '')
    localStorage.setItem("user.username", user.username || '')
    localStorage.setItem("user.impersonated", user.impersonated ? 'yes' : 'no')
  }

  getUser(): User | undefined {
    if (localStorage.getItem("user.name") !== null && this.getPersistenceToken() !== null) {
      const user = new User()
      user.name = localStorage.getItem("user.name") || ''
      user.username = localStorage.getItem("user.username") || ''
      user.email = localStorage.getItem("user.email") || ''
      user.persistenceToken = this.getPersistenceToken() || ''
      user.impersonated = this.isImpersonated()
      return user
    } else {
      return undefined
    }
  }

  resetUser() {
    localStorage.removeItem("user.name")
    localStorage.removeItem("user.email")
    localStorage.removeItem("user.username")
    localStorage.removeItem("user.impersonated")
  }

}
